const language =
    {
        es: {
            restorepasslbl:'Genere una nueva contraseña',
            confirmActionLabel: 'Confirmar acción',
            yesLabel: 'Si',
            noLabel: 'No',
            forgotMessage: 'Se envió un mensaje al correo {0} para cambiar la clave, por favor sigue las instrucciones del mismo para continuar',
            forgotPassword: '¿Olvidó su clave?',
            advUserLabel: 'Usuario',
            advSignDateLabel: 'Fecha de firma',
            advStatusLabel: 'Estado',
            advDetailLabel: 'Detalle',
            advPendingLabel: 'Pendiente por firmar',
            advSignedLabel: 'Firmado',
            advWorkflowMenu: 'Archivos pendientes',
            advFileNameLabel:'Nombre del archivo',
            advCreationDateLabel:'Fecha de creación',
            advActionsLabel: 'Ver historial',
            advTrackLabel: 'Ver detalle',
            advWorkflowInfo: 'Archivos enviados pendientes por firmar',
            advResultsPerPage: 'Resultados por pagina: ',
            advTotalElements: 'Total de $0 elementos',
            advSentToMenu: 'Enviar a firma',
            advLogout:'Cerrar sesión',
            advCoordLabel: 'Correo del Jefe de sala: ',
            advOKMessage:'Archivos cargados correctamente',
            advSendToButtonLabel:'Enviar a firma',
            advCommentLabel:'Deje un comentario o instrucciones a su cliente',
            advSendToLabel:'Enviar a:',
            advSelectTemplate:'Seleccione los documentos a enviar al correo: ',
            advOrdersLabel:'Elija el número de pedido que desea enviar a firma',
            advOrdersButtonLabel:'SELECCIONAR',
            advTitleIDLabel:'ENVIAR DOCUMENTOS A FIRMA',
            advButtonIDLabel:'VALIDAR',
            advIDLabel:'Digite el número de cédula del cliente',
            userExistsInfo: 'Por favor digite su usuario y contraseña de Netco Signer',
            signUpText: 'Para iniciar por favor digite su número de cédula',
            cnLabel: 'Nombre Completo:',
            mailLabel:'Correo electrónico:',
            areaLabel: 'Código de area',
            phoneLabel:'Número de celular/movil:',
            idLabel:'ID / Cédula',
            nextLabel:'SIGUIENTE',
            backLabel: 'REGRESAR',
            requiredError: 'Campo requerido',
            invalidEmail:' Correo inválido',
            signUpText2: 'Al completar el formulario recibirá un email o mensaje de texto con un código de validación para completar el proceso de creación de cuenta.',
            countryLabel:'País',
            stateLabel: 'Departamento/Estado',
            cityLabel: 'Ciudad:',
            addressLabel: 'Dirección:',
            signUpText3: 'Por favor tome o cargue una foto de su {0}',
            frontIdLabel:'Frente',
            backIdLabel: 'Respaldo',
            signUpText4: 'Por favor tome una foto de su {0}',
            takePictureLabel: 'Tomar una foto',
            uploadLabel: 'Cargar un archivo',
            validateAccountLabel: 'VALIDAR CUENTA',
            serverError: 'Error conectando al servidor',
            loadingLabel: 'Cargando...',
            takePictureFront: 'Acerque su documento por la parte frontal a la camara y haga click en tomar foto',
            takePictureBack: 'Acerque su documento por la parte posterior a la camara y haga click en tomar foto',
            takePictureLabelOk: 'Tomar foto',
            takePictureLabelCancel: 'Cancelar',
            frontRequired: 'La imagen de frente es requerida',
            backRequired: 'La imagen posterior es requerida',
            confirmationLabel: 'Por favor valide sus datos. Es importante que los datos estén correctos ya que estos se utilizarán para el proceso de matrícula de su vehículo ante las autoridades de tránsito',
            confirmationLabel2: 'Si unos de sus datos es incorrecto, no continue con el proceso de firma y por favor pongase en contacto con su asesor comercial para las correcciones correspondientes',
            refLabel: 'Número de referencia',
            authCodeLabel: 'Código de seguridad',
            passwordLabel: 'Contraseña',
            confirmLabel: 'Confirmar contraseña',
            codesLabel: 'HEMOS ENVIADO A SU CELULAR UN CÓDIGO DE SEGURIDAD DE 6 DÍGITOS',
            resendLabel:'¿No le ha llegado el código? Click aquí para reenviar',
            regenOK: 'Códigos enviados correctamente',
            userLabel:'Usuario',
            idTypeLabel:'Tipo de identificación:',
            genderLabel: 'Género:',
            birthLabel: 'Fecha de nacimiento:',
            cancelLabel: 'CANCELAR',
            createLabel: 'CREAR CUENTA Y FIRMAR',
            inputCodeLabel: 'Digite el código de seguridad y cree una contraseña',
            errorIDNotmatch: 'El correo incluido en el link no coincide con los registros, por favor contacte a su asesor comercial',
            dataLabels: {
                first:{
                    razon_comercial:'Nombre Completo:',
                    tipo_doc: 'Tipo de identificación:',
                    cedula: 'ID / Cédula:',
                    gender:'Género:',
                    dateOfBirth:'Fecha de nacimiento:'
                },
                last:{
                    ciudad:'Ciudad:',
                    direccion:'Dirección:',
                    mail:'Correo electrónico:',
                    telefono:'Número de celular/movil:',
                    country: 'País'
                }
            }
        },
        en:{
            restorepasslbl:'undefined',
            confirmActionLabel: 'undefined',
            yesLabel: 'undefined',
            noLabel: 'undefined',
            forgotMessage: 'undefined',
            forgotPassword: 'undefined',
            advUserLabel: 'undefined',
            advSignDateLabel: 'undefined',
            advStatusLabel: 'undefined',
            advDetailLabel: 'undefined',
            advPendingLabel: 'undefined',
            advSignedLabel: 'undefined',
            advWorkflowMenu: 'undefined',
            advFileNameLabel:'undefined',
            advCreationDateLabel:'undefined',
            advActionsLabel: 'undefined',
            advTrackLabel: 'undefined',
            advWorkflowInfo: 'undefined',
            advResultsPerPage: 'undefined',
            advTotalElements: 'undefined',
            advSentToMenu: 'undefined',
            advLogout:'undefined',
            advCoordLabel: 'undefined',
            advOKMessage:'undefined',
            advSendToButtonLabel:'undefined',
            advCommentLabel:'undefined',
            advSendToLabel:'undefined',
            advSelectTemplate:'undefined',
            advOrdersLabel:'undefined',
            advOrdersButtonLabel:'undefined',
            advTitleIDLabel:'undefined',
            advButtonIDLabel:'undefined',
            advIDLabel:'undefined',
            userExistsInfo: 'undefined',
            signUpText: 'undefined',
            cnLabel: 'undefined',
            mailLabel:'undefined',
            areaLabel: 'undefined',
            phoneLabel:'undefined',
            idLabel:'undefined',
            nextLabel:'undefined',
            backLabel: 'undefined',
            requiredError: 'undefined',
            invalidEmail: 'undefined',
            signUpText2:'undefined',
            countryLabel:'undefined',
            stateLabel: 'undefined',
            cityLabel: 'undefined',
            addressLabel: 'undefined',
            signUpText3: 'undefined',
            frontIdLabel:'undefined',
            backIdLabel: 'indefined',
            signUpText4: 'undefined',
            takePictureLabel: 'undefined',
            uploadLabel:'undefined',
            validateAccountLabel: 'undefined',
            serverError: 'undefined',
            loadingLabel: 'undefined',
            takePictureFront: 'undefined',
            takePictureBack: 'undefined',
            takePictureLabelOk: 'undefined',
            takePictureLabelCancel: 'undefined',
            frontRequired: 'undefined',
            backRequired: 'undefined',
            confirmationLabel: 'undefined',
            confirmationLabel2: 'undefined',
            codesLabel: 'undefined',
            resendLabel:'undefined',
            regenOK: 'undefined',
            userLabel:'undefined',
            idTypeLabel:'undefined',
            genderLabel: 'undefined',
            birthLabel: 'undefined',
            cancelLabel: 'undefined',
            createLabel: 'undefined',
            inputCodeLabel: 'undefined',
            errorIDNotmatch: 'undefined',
            dataLabels: {
                first:{
                    fullName:'undefined',
                    idType: 'undefined',
                    cedula: 'undefined',
                    gender:'undefined',
                    dateOfBirth:'undefined'
                },
                last:{
                    city:'undefined',
                    direccion:'undefined',
                    mail:'undefined',
                    telefono:'undefined'
                }
            }
        }
    };
export default language;